import axios from 'axios';
import { api_url, mg_token_name } from '../config/Params.constant';
import storage from './Storage';

class CaisseService {

    createDoc(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/caisse/doc-client`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    updateDoc(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.put(`${api_url}/caisse/doc-client/${data?.idDoc}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    filterDoc(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/caisse/doc-client/filter`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    listAcompteReady() {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/caisse/acompte/ready`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    tranformDevis(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/caisse/doc-client/devis/to-acompte/${data?.idDoc}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    facturerDoc(idDoc) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/caisse/doc-client/acompte/facturer/${idDoc}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    annulerDoc(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/caisse/doc-client/acompte/annuler/${data?.idDoc}`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    viewFactureClient(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/caisse/doc-client/facture/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }


    removeDoc(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.delete(`${api_url}/caisse/doc-client${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    viewDoc(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/caisse/doc-client/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    createAcompte(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/caisse/acompte`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    filterAcompte(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/caisse/acompte/filter`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    createPaiement(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/caisse/paiement`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    validatePaiement(num) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/caisse/paiement/validate/${num}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    annulerPaiement(num) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/caisse/paiement/annuler/${num}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }
    
    listPaiementCheque() {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/caisse/paiement/cheque/list`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    filterMvm(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/caisse/mvm/filter`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    createAvoir(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/caisse/avoir-client`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    filterAvoir(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/caisse/avoir-client/filter`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    viewAvoir(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/caisse/avoir-client/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    getDispoAvoirByClient(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/caisse/avoir-client/dispo/client/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }


    createRelance(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.post(`${api_url}/caisse/relance`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    updateRelance(data) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.put(`${api_url}/caisse/relance`, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    deleteRelance(id) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.delete(`${api_url}/caisse/relance/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    listRelance() {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/caisse/relance/list`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }




    envoyerDocMail(idDoc) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.get(`${api_url}/caisse/doc-client/envoyer-devis/${idDoc}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }

    generateDevisPaiement(ids) {
        let token = storage.getToken();
        let mgToken = storage.getMgToken();
        return axios.patch(`${api_url}/caisse/doc-client/generate-30-stripe-pay?ids=${Array(ids).toString()}`,{}, {
            headers: {
                Authorization: `Bearer ${token}`,
                [mg_token_name]: `${mgToken}`
            }
        });
    }


}

export default new CaisseService()